// extracted by mini-css-extract-plugin
export default {"caret":"caret___XOiuV","expanded":"expanded___XtyAc","borderRadius":"borderRadius___bF6Dg"};